import { create } from 'zustand';
import {
  NexoyaBudgetDeltaHandlingPolicy,
  NexoyaFeatureFlag,
  NexoyaFunnelStepV2,
  NexoyaImpactGroup,
  NexoyaOptimizationType,
  NexoyaPortfolioDashboardUrl,
  NexoyaPortfolioLabel,
  NexoyaPortfolioTargetItem,
  NexoyaPortfolioType,
  NexoyaTargetBiddingApplyMode,
} from '../types';

interface PortfolioMeta {
  budgetDeltaHandlingPolicy?: NexoyaBudgetDeltaHandlingPolicy;
  budgetProposalTargetBiddingApplyMode?: NexoyaTargetBiddingApplyMode;
  createdByUserId?: number;
  defaultOptimizationTarget?: NexoyaFunnelStepV2;
  description?: string;
  end?: Date;
  featureFlags?: NexoyaFeatureFlag[];
  impactGroups: NexoyaImpactGroup[];
  labels: NexoyaPortfolioLabel[];
  latestAchievedTargetItem?: NexoyaPortfolioTargetItem;
  optimizationRiskLevel?: number;
  optimizationType?: NexoyaOptimizationType;
  portfolioDashboardUrls?: NexoyaPortfolioDashboardUrl[];
  portfolioId: number;
  skipTrainingDays?: number;
  start?: Date;
  targetItems: NexoyaPortfolioTargetItem[];
  teamId: number;
  title: string;
  type: NexoyaPortfolioType;
  isAttributed: boolean;
}

const createInitialPortfolioMeta = (): PortfolioMeta => ({
  impactGroups: [],
  labels: [],
  targetItems: [],
  portfolioId: 0,
  teamId: 0,
  title: '',
  type: null,
  isAttributed: false,
});

type PortfolioMetaStore = {
  portfolioMeta: PortfolioMeta;
  setPortfolioMeta: (data: PortfolioMeta) => void;
  resetPortfolioMeta: () => void;
  error: string | null;
  setError: (error: string | null) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
};

const usePortfolioMetaStore = create<PortfolioMetaStore>((set) => ({
  portfolioMeta: createInitialPortfolioMeta(),
  setPortfolioMeta: (data) => set({ portfolioMeta: data }),
  resetPortfolioMeta: () => set({ portfolioMeta: createInitialPortfolioMeta() }),
  error: null,
  setError: (error) => set({ error }),
  loading: false,
  setLoading: (loading) => set({ loading }),
}));

export default usePortfolioMetaStore;
